import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root : {
        borderRadius : 24,
        padding : 24,
        background : "#2D2D2D",
        color : "white",
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    }
}))

export default useStyles